// Single source of truth for brand, contact and SEO defaults.
// Update SITE_URL to the live domain before deploying — canonical tags,
// the sitemap and social share cards are all derived from it.
export const SITE_URL = "https://www.synani.com";

export const BRAND = {
  name: "SYNANI Talent Solutions",
  shortName: "SYNANI",
  tagline: "Talent That Moves Businesses Forward",
  description:
    "SYNANI Talent Solutions is a talent solutions and staffing company helping organizations find and engage skilled professionals across IT and Non-IT domains.",
};

export const CONTACT = {
  email: "contact@synani.com",
  phone: "+91 XXXXX XXXXX",
  location: "Chennai, Tamil Nadu, India",
  city: "Chennai",
  region: "Tamil Nadu",
  country: "IN",
};

export const SOCIAL = {
  linkedin: "https://www.linkedin.com/company/synani",
  instagram: "https://www.instagram.com/synani",
  facebook: "https://www.facebook.com/synani",
};

export const DEFAULT_SEO = {
  title: `${BRAND.name} | IT & Non-IT Recruitment & Staffing Company`,
  description:
    "IT & Non-IT recruitment and staffing company in Chennai, India. Contract and permanent staffing, RPO services and executive search — talent that moves businesses forward.",
  image: `${SITE_URL}/og-image.png`,
};
